import HomePageRoutes from './HomePage_routes'
import PlatformAdminRoutes from './PlatformAdmin_routes'
import epayRoutes from './epay_routes.js'
import pmsRoutes from './pms_routes.js'
import PickCollRoutes from './PickColl_routes'
import OrderRoutes from './order_routes'
import fullReductionRoutes from './fullReduction_routes'
import appRouters from './app_routes'
import videoRoutes from './video_routes'

const routes = [{
  path: '/',
  name: 'Home',
  redirect: '/hqsyshome',
  component: () => import('@/views/Home.vue'),
  children: [
    ...HomePageRoutes,
    ...PlatformAdminRoutes,
    ...OrderRoutes,
    ...fullReductionRoutes,
    ...pmsRoutes,
    ...epayRoutes,
    ...PickCollRoutes,
    ...appRouters,
    ...videoRoutes,

    { path: '/CacheRefresh', component: () => import('@/views/MaintenanceMenu/CacheRefresh/index.vue') },

    { path: '/customerinfo', component: () => import('@/views/CustomerAdmin/CustomerInfo/index.vue') },
    { path: '/customerdetails', component: () => import('@/views/CustomerAdmin/CustomerInfoDetails/index.vue') },
    { path: '/complain', component: () => import('@/views/CustomerAdmin/ComplainList/index.vue') },
    { path: '/fieldAdmin', component: () => import('@/views/CustomerAdmin/FieldAdmin/index.vue') },

    { path: '/myaccountinfo', component: () => import('@/views/MyAccountAdmin/Account/index') },
    { path: '/myaccountpass', component: () => import('@/views/MyAccountAdmin/Password/index') },

    { path: '/AfterSaleList', component: () => import('@/views/AfterSale/List/index.vue') },
    { path: '/AfterSaleProblemAdmin', component: () => import('@/views/AfterSale/ProblemAdmin/index.vue') }
  ]
},
{ path: '/login', name: 'login', component: () => import('@/views/Login/index.vue') },
{ path: '*', redirect: '/login', name: 'notFound', hidden: true },

{ path: '/app/chatWindow', component: () => import('@/views/Service/chatWindow.vue') }

]
export default routes
